<div class="flex h-screen">

  <app-sidebar />

  <div class="flex flex-col flex-grow min-h-0 min-w-0">
    <app-bar />

    <div class="flex-grow overflow-auto bg-surface-container min-h-0">
      <div class="p-6">
        <router-outlet />
      </div>
    </div>
  </div>

</div>
